import styled from "styled-components";
import { breakpoints } from "../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div`
    display: flex;
    flex-basis: 100%;
    flex-direction: column;
    row-gap: var(--spacing-3);

    @supports not (row-gap: 0) {
        & > div {
            margin-top: var(--spacing-3);
        }
    }
`;

export const Ctas = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-1);

    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
        column-gap: var(--spacing-2);
        row-gap: normal;
    }

    @supports not (row-gap: 0) {
        & > button:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-1);

            @media (min-width: ${breakpoints.lg}) {
                margin-bottom: 0;
                margin-right: var(--spacing-2);
            }
        }
    }

    &:has(:nth-child(n + 1)) {
        button,
        div {
            flex-basis: 50%;
        }
    }

    &:has(:nth-child(3)) {
        button,
        div {
            flex-basis: 33.33333%;
        }
    }
`;
